import * as firebase from "firebase";
import "firebase/auth"
import "firebase/firestore";
require("firebase/firestore");

// Your web app's Firebase configuration
const { VUE_APP_API_KEY,
VUE_APP_AUTH_DOMAIN,
VUE_APP_DB_URL,
VUE_APP_STORAGE,
VUE_APP_PROJECT_ID,
VUE_APP_SENDING_ID,
VUE_APP_APP_ID } = process.env

export const firebaseConfig = {
  apiKey: VUE_APP_API_KEY,
  authDomain: VUE_APP_AUTH_DOMAIN,
  databaseURL: VUE_APP_DB_URL == "" ? null : VUE_APP_DB_URL,
  projectId: VUE_APP_PROJECT_ID,
  storageBucket: VUE_APP_STORAGE,
  messagingSenderId: VUE_APP_SENDING_ID,
  appId: VUE_APP_APP_ID
};


// Initialize Firebase
export const secondary = firebase;
const fb = firebase.initializeApp(firebaseConfig); // fb for firebase
const db = firebase.firestore(); // db for database
const auth = firebase.auth()


export { fb, db, auth };
